var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeBannerVecotr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 157,
    viewBox: "0 0 1440 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.5 83C872.187 144.701 1048.55 168.473 1246.78 78.9619C1515.48 -42.3712 1587 109.296 1587 109.296V156.962H-338V0.961914L-171.5 68C150 -21 337 13.5 620.5 83Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBannerVecotr);
export default __webpack_public_path__ + "static/media/homeBannerVecotr.255a61674b354543fb3570bc84690d25.svg";
export { ForwardRef as ReactComponent };